module.exports = __webpack_public_path__ + "static/img/2en.5116bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/2en.png
// module id = npWP
// module chunks = 0